export default "__VITE_ASSET__2069a9e4__"